export enum ESalesFunnelView {
    FUNNEL = 'funnel',
    DATA = 'data',
}

export enum ESalesFunnelType {
    DEFAULT = 'default',
    RUC = 'ruc',
}

export enum EStageId {
    ALL_SCHOOLS = 0,
    PROSPECTING = 1,
    PROSPECT_IDENTIFIED = 2,
    DEMO_COMPLETED = 3,
    PROPOSAL_SUBMITTED = 4,
    CONTRACT_NEGOTIATION = 5,
    SSF_SIGNED = 6,
    DEAL_WON = 7,
    DROPPED = 8,
    DEFERRED = 9,
}

export enum EDealsPipelineStageRange {
    DEALS_COUNT_START = 3,
    DEALS_COUNT_END = 7,
    PIPELINE_VALUE_START = DEALS_COUNT_START,
    PIPELINE_VALUE_END = 6,
}

export enum EDealsPipelineFilterType {
    STAGE = 'stage',
    PRODUCT = 'product',
    CITY = 'city',
}
